module.exports = __webpack_public_path__ + "img/1728609481469-Screenshot_11-10-2024_91748_www.instagram.com.jpeg.13f9a60f.webp";